export default __webpack_public_path__ + "img/1077.4edc81c.svg";